export interface AppConfig {
  apiBase: string;
  uploadTimeout: number;
  processingTimeout: number;
  maxFileSize: number;
  supportedFileTypes: string[];
  enableDragDrop: boolean;
  enableAdvancedOptions: boolean;
  enableDebugMode: boolean;
  defaultFormValues: {
    llmModelProvider: 'openrouter' | 'google';
    pdfDpi: number;
    leadingLineLimit: number;
    trailingLineLimit: number;
    autoAdjustImageSize: boolean;
    isWorkspace: boolean;
    addPrompt: boolean;
  };
  defaultBankStatementFormValues: {
    llmModelProvider: 'openrouter' | 'google';
    includeText: boolean;
    includeImage: boolean;
    isWorkspace: boolean;
    pdfDpi: number;
    autoAdjustImageSize: boolean;
    batchSize: number;
    addPrompt: boolean;
  };
}

// Extend Window interface to include appConfig
declare global {
  interface Window {
    appConfig: AppConfig;
  }
}

// Fallback configuration in case window.appConfig is not loaded
const fallbackConfig: AppConfig = {
  apiBase: '',
  uploadTimeout: 600000,
  processingTimeout: 1200000,
  maxFileSize: 52428800,
  supportedFileTypes: ['application/pdf'],
  enableDragDrop: true,
  enableAdvancedOptions: true,
  enableDebugMode: false,
  defaultFormValues: {
    llmModelProvider: 'openrouter',
    pdfDpi: 150,
    leadingLineLimit: 15,
    trailingLineLimit: 15,
    autoAdjustImageSize: true,
    isWorkspace: false,
    addPrompt: false,
  },
  defaultBankStatementFormValues: {
    llmModelProvider: 'openrouter',
    includeText: true,
    includeImage: true,
    isWorkspace: false,
    pdfDpi: 150,
    autoAdjustImageSize: true,
    batchSize: 10,
    addPrompt: false,
  }
};

// Load configuration from window.appConfig or use fallback
export const config: AppConfig = {
  ...fallbackConfig,
  ...(window.appConfig || {})
};

// Feature flags (derived from config)
export const features = {
  enableDragDrop: config.enableDragDrop,
  enableAdvancedOptions: config.enableAdvancedOptions,
  enableDebugMode: config.enableDebugMode,
};

// API endpoints
export const endpoints = {
  ping: '/ping',
  generateUploadUrl: '/generate-upload-url',
  splitAndClassify: '/split-and-classify',
  upload: '/upload',
  bankStatementExtract: '/bank-statement-extract',
};
